/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, FormGroup, Label, Table } from 'reactstrap';
import { Field, FieldArray, reduxForm } from 'redux-form';
import TextInput from '../../../common/forms/input/TextInput';
import { isRequired } from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import Loader from '../../../common/Loader';
import FormFooter from '../../../common/forms/FormFooter';
import DynamicForm from '../../../common/forms/DynamicForm';
import { FREE_OF_CHARGE_SUB_CATEGORY_COLUMNS } from '../../../../config/dynamicFormFields';
import CustomerSelect from '../../../common/forms/select/CustomerSelect';

const ExistingSubcategoriesTable = ({ fields }) => {
  const items = fields.getAll() || [];
  return (
    <Table bordered responsive>
      <thead>
        <tr>
          <th>Nombre</th>
          <th>Activo</th>
          <th>Autorizadores </th>
        </tr>
      </thead>
      <tbody>
        {items.length === 0 && (
          <tr>
            <td colSpan="3">No hay subcategorías.</td>
          </tr>
        )}
        {fields.map((name, index) => (
          <tr key={`${name}-${items[index].id || index}`}>
            <td>
              <Field
                name={`${name}.name`}
                component={TextInput}
                type="text"
                disabled
              />
              <Field name={`${name}.id`} component="input" type="hidden" />
            </td>

            <td style={{ width: 120 }}>
              <Label className="mb-0">
                <Field
                  name={`${name}.active`}
                  component="input"
                  type="checkbox"
                />{' '}
                Activo
              </Label>
            </td>

            <td>
              <Field
                name={`${name}.authorizers`}
                component={CustomerSelect}
                isMulti
              />
              <small className="text-muted">
                Esta selección reemplaza la lista completa de autorizadores.
              </small>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export const FreeOfChargeCategoryForm = ({ handleSubmit, loading, edit }) => {
  if (loading) return <Loader />;

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Nombre" required>
          <Field
            name="name"
            component={TextInput}
            type="text"
            placeholder="Nombre"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Descripción" required>
          <Field
            name="description"
            component={TextInput}
            type="text"
            placeholder="Descripción"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      {!edit && (
        <FormGroup row>
          <FormItem label="Autorizadores">
            <Field
              name="freeOfChargeSubCategoryUserList"
              component={CustomerSelect}
              isMulti
            />
          </FormItem>
        </FormGroup>
      )}

      <h3>Subcategorías</h3>

      {!edit && (
        <DynamicForm
          name="freeOfChargeSubCategoryList"
          columns={FREE_OF_CHARGE_SUB_CATEGORY_COLUMNS}
        />
      )}

      {edit && (
        <>
          <h5 className="mt-3">Existentes</h5>
          <FieldArray
            name="freeOfChargeSubCategoryList"
            component={ExistingSubcategoriesTable}
          />

          <h5 className="mt-4">Agregar nuevas</h5>
          <DynamicForm
            name="newFreeOfChargeSubCategoryList"
            columns={FREE_OF_CHARGE_SUB_CATEGORY_COLUMNS}
          />
        </>
      )}

      <FormGroup row>
        <FormItem>
          <Label>
            <Field
              name="active"
              id="active"
              component="input"
              type="checkbox"
            />{' '}
            Activo
          </Label>
        </FormItem>
      </FormGroup>

      <FormFooter />
    </Form>
  );
};

FreeOfChargeCategoryForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  edit: PropTypes.bool,
};

FreeOfChargeCategoryForm.defaultProps = {
  loading: false,
  edit: false,
};

const mapStateToProps = (state) => ({
  loading: !state.SalesUnit.FreeOfChargeCategory.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: 'FreeOfChargeCategoryForm',
})(FreeOfChargeCategoryForm);

export default connect(mapStateToProps, null)(formComponent);
